import { createEnum } from '../utils/actionTypesHelpers';

export default createEnum(
  {
    add: null,
    remove: null,
  },
  'notification',
);
